import { createRoot } from "react-dom/client";
import NorthStarRoadmap from "./northstar-roadmap-explorer.jsx";

const container = document.getElementById("roadmap-explorer-root");
if (container) {
  createRoot(container).render(<NorthStarRoadmap />);
}
